//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  layout: 'error',
  props: {
    searchTerm: {
      type: String,
      default: null,
    },
    notFound: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      illustrations: [
        {
          number: 1,
          src: require(`~/assets/img/element-hear-02.svg?data`),
          width: 157,
          height: 135,
          alt: '',
        },
        {
          number: 2,
          src: require(`~/assets/img/element-connect-06.svg?data`),
          width: 95,
          height: 143,
          alt: '',
        },
        {
          number: 3,
          src: require(`~/assets/img/element-connect-07.svg?data`),
          width: 164,
          height: 139,
          alt: '',
        },
        {
          number: 4,
          src: require(`~/assets/img/element-learn-06.svg?data`),
          width: 222,
          height: 476,
          alt: '',
        },
        {
          number: 5,
          src: require(`~/assets/img/element-learn-04.svg?data`),
          width: 119,
          height: 141,
          alt: '',
        },
      ],
    }
  },
  computed: {
    filteredIllustrations() {
      return this.notFound
        ? this.illustrations
        : this.illustrations.filter(illustration => ![2, 3, 5].includes(illustration.number));
    }
  },
}
